import { Tooltip } from "@similarweb/ui-components";

import { StyledButtonContainer, StyledIconButton } from "./styles";

interface IAddListButtonProps {
    text: string;
    onClick: () => void;
    hasAccess?: boolean;
    disabledTooltip?: string;
}

const AddListButton = ({ text, onClick, disabledTooltip, hasAccess = true }: IAddListButtonProps) => {
    const button = (
        <StyledButtonContainer>
            <StyledIconButton
                iconName="add"
                type="flat"
                isDisabled={!hasAccess}
                onClick={onClick}
            >
                {text}
            </StyledIconButton>
        </StyledButtonContainer>
    );

    if (!hasAccess) {
        return <Tooltip content={disabledTooltip}>{button}</Tooltip>;
    }

    return button;
};

export default AddListButton;
